
import { map, mergeMap } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import {
  GET_RECENT_TRANSACTIONS,
  getRecentTransactionsActionCreator,
  GET_SIMILAR_TRANSACTIONS,
  getSimilarTransactionsActionCreator,
} from 'actions/moneyflowActions'
import { GET_TRANSACTIONS_URL } from 'interfaces/ajax'
import { empty, of } from 'rxjs'
import * as moment from 'moment'
import { RECENT_TRANSACTIONS_LIMIT } from 'constants/moneyflow'
import { saturateTransactions } from 'helpers/rawHelpers'
import { GetPaginatedTransactionsApiPayload, GetSimilarTransactionsApiPayload } from 'interfaces/ajax/payload'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { accountsFilterQueryParamSelector } from 'components/features/pageFilters/selectors'

const getRecentTransactionsEpic: Epic = (action$, store, { get }) => action$
  .pipe(filterRequestOfType(GET_RECENT_TRANSACTIONS, 'request')).pipe(
    mergeMap((action) => {
      const state = store.getState()

      const apiPayload: GetPaginatedTransactionsApiPayload = {
        page_size: RECENT_TRANSACTIONS_LIMIT,
        page: 1,
        ordering: '-date',
        start_date: moment().subtract(1, 'year').format('YYYY-MM'),
        end_date: moment().format('YYYY-MM'),
        excluded_account_uids: accountsFilterQueryParamSelector(state),
      }

      return get(GET_TRANSACTIONS_URL, apiPayload).pipe(
        mergeMap(({ response }) => {
        // pagination
          if (!('results' in response)) {
            return empty()
          }

          const transactions = saturateTransactions(response.results, state.data.meta)
          return of(getRecentTransactionsActionCreator.success(action.payload.params, { transactions }))
        }))
        .pipe(catchAjaxSafe((error) => {
          return of(getRecentTransactionsActionCreator.fail(action.payload.params, error.status))
        }))
    }))

const getSimilarTransactionsEpic: Epic = (action$, store, { get }) => action$
  .pipe(filterRequestOfType(GET_SIMILAR_TRANSACTIONS, 'request')).pipe(
    mergeMap((action) => {
      const apiPayload: GetSimilarTransactionsApiPayload = {
        similar_to: action.payload.params.targetTransactionId,
      }

      return get(GET_TRANSACTIONS_URL, apiPayload).pipe(
        map(({ response }) => {
          const state = store.getState()

          // no pagination
          if ('results' in response) {
            return empty()
          }

          const nextTransactions = saturateTransactions(response, state.data.meta)
          return getSimilarTransactionsActionCreator.success(action.payload.params, nextTransactions)
        }))
        .pipe(catchAjaxSafe((error) => {
          return of(getSimilarTransactionsActionCreator.fail(action.payload.params, error.status))
        }))
    }))


export const transactionEpic = combineEpics(
  getRecentTransactionsEpic,
  getSimilarTransactionsEpic,
)
